import React from 'react';
import { Flex, Box, Text } from 'pcln-design-system';
import { RatingDivider } from './Ratings.styles';
const Ratings = ({
  guestRating,
  hotelRating,
  overallRating
}) => {
  return React.createElement(Flex, {
    alignItems: 'center'
  }, React.createElement(Box, {
    bg: 'alert.base',
    borderRadius: 'md',
    textAlign: 'center'
  }, React.createElement(Text, {
    color: 'text.lightest',
    fontSize: 0,
    fontWeight: 'bold',
    lineHeight: '16px',
    p: '2px',
    px: '7px'
  }, overallRating)), React.createElement(Box, null, React.createElement(Text, {
    fontSize: '11px',
    lineHeight: '15px',
    ml: 2,
    color: 'text.base'
  }, guestRating, " Ratings")), Number(hotelRating) > 0 ? React.createElement(Flex, {
    alignItems: 'center'
  }, React.createElement(RatingDivider, {
    "data-testid": 'rating-divider'
  }), React.createElement(Box, null, React.createElement(Text, {
    fontSize: '11px',
    lineHeight: '15px',
    color: 'text.base'
  }, hotelRating, "-Star Hotel"))) : null);
};
export default Ratings;